export default __webpack_public_path__ + "static/media/menu-dots.ddeb74f5.svg";